/*
 * Mar Amoli — Calculadora de dilución de aceites esenciales.
 *
 * La cuenta es una línea; el resto es que no se pueda usar mal:
 *   · un uso marcado "sin número" no calcula nada, manda con un profesional.
 *     Es el caso de los bebés, donde dar una cifra sería irresponsable.
 *   · el campo de mililitros se acota a un rango sensato, y un valor inválido
 *     no pinta "NaN gotas": no pinta nada.
 *
 * Los pasos aparecen conforme se contestan. Con 4 usos y un campo, un
 * formulario completo de golpe se ve como trámite; de uno en uno se ve corto.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-ma-dil]');
  if (!raiz) return;

  var GOTAS_ML = parseFloat(raiz.getAttribute('data-gotas-ml')) || 20;
  var ML_MIN = 1;
  var ML_MAX = 1000;

  var usos = [].slice.call(raiz.querySelectorAll('[data-ma-dil-uso]'));
  var paso2 = raiz.querySelector('[data-ma-dil-paso2]');
  var campoMl = raiz.querySelector('[data-ma-dil-ml]');
  var atajos = [].slice.call(raiz.querySelectorAll('[data-ma-dil-atajo]'));

  var resultado = raiz.querySelector('[data-ma-dil-resultado]');
  var cifraWrap = raiz.querySelector('[data-ma-dil-cifra-wrap]');
  var salidaGotas = raiz.querySelector('[data-ma-dil-gotas]');
  var salidaDetalle = raiz.querySelector('[data-ma-dil-detalle]');
  var salidaNota = raiz.querySelector('[data-ma-dil-nota]');
  var bloqueo = raiz.querySelector('[data-ma-dil-bloqueo]');
  var bloqueoTexto = raiz.querySelector('[data-ma-dil-bloqueo-texto]');
  var tienda = raiz.querySelector('[data-ma-dil-tienda]');
  var grid = raiz.querySelector('[data-ma-dil-aceites-grid]');
  var paso3 = raiz.querySelector('[data-ma-dil-paso3]');
  var chips = raiz.querySelector('[data-ma-dil-chips]');

  var elegido = null;
  var aceite = null;
  var catalogo = [];

  /* ── utilidades ────────────────────────────────────────────── */

  function ml() {
    var v = parseFloat(campoMl && campoMl.value);
    if (!isFinite(v) || v < ML_MIN || v > ML_MAX) return null;
    return v;
  }

  // Media gota no existe: se redondea. Pero por debajo de 1 gota redondear a 0
  // diría "no le pongas nada", que es falso — ahí el mensaje es otro.
  function gotas(mililitros, pct) {
    return (mililitros * (pct / 100)) * GOTAS_ML;
  }

  function plural(n, singular, pluralPalabra) {
    return n === 1 ? singular : pluralPalabra;
  }

  /* ── pintado ───────────────────────────────────────────────── */

  function limpiar() {
    resultado.hidden = true;
    if (tienda) tienda.hidden = true;
  }

  function pintar() {
    if (!elegido) return limpiar();

    var sinNumero = elegido.getAttribute('data-sin-numero') === 'true';
    var nombre = elegido.getAttribute('data-nombre') || '';
    var nota = elegido.getAttribute('data-nota') || '';

    resultado.hidden = false;

    if (sinNumero) {
      cifraWrap.hidden = true;
      salidaDetalle.textContent = '';
      salidaNota.hidden = true;
      bloqueo.hidden = false;
      bloqueoTexto.textContent = nota ||
        'Para este caso no damos una cifra: consulta a un profesional de la salud.';
      if (tienda) tienda.hidden = true;
      return;
    }

    bloqueo.hidden = true;
    cifraWrap.hidden = false;

    var mililitros = ml();
    if (mililitros === null) {
      salidaGotas.textContent = '—';
      salidaDetalle.textContent =
        'Escribe cuántos mililitros de aceite portador vas a usar (entre ' +
        ML_MIN + ' y ' + ML_MAX + ').';
      salidaNota.hidden = true;
      if (tienda) tienda.hidden = true;
      return;
    }

    // El porcentaje del uso es un techo general; el aceite puede tener uno más
    // bajo. Cuando lo tiene, manda el del aceite — y se dice, porque un número
    // que cambia solo sin explicación se lee como un error.
    var pctUso = parseFloat(elegido.getAttribute('data-pct'));
    var pct = pctUso;
    var limitadoPor = null;
    if (aceite && aceite.tope > 0 && aceite.tope < pctUso) {
      pct = aceite.tope;
      limitadoPor = aceite;
    }

    var n = gotas(mililitros, pct);
    var redondeado = Math.round(n);

    if (n < 1) {
      // Con muy poco portador la cuenta da menos de una gota. Decir "0 gotas"
      // sería falso; lo honesto es proponer preparar un poco más.
      salidaGotas.textContent = '<1';
      salidaDetalle.textContent =
        'Con ' + mililitros + ' ml al ' + pct + '% sale menos de una gota. ' +
        'Prepara una cantidad mayor para poder medirlo bien.';
    } else {
      salidaGotas.textContent = String(redondeado);
      salidaDetalle.textContent =
        redondeado + ' ' + plural(redondeado, 'gota', 'gotas') + ' en ' +
        mililitros + ' ml de aceite portador — una dilución al ' + pct + '%. ' +
        'La cuenta usa ' + GOTAS_ML + ' gotas por mililitro.';
    }

    // La explicación del tope va ANTES que la nota del uso: es la que responde
    // "¿por qué me salieron menos gotas que hace un segundo?".
    var textoNota = nota;
    if (limitadoPor) {
      // Sin artículo antes del nombre: "el Canela de corteza" no funciona y el
      // género del aceite no se puede deducir de la cadena.
      textoNota =
        'Bajamos del ' + pctUso + '% al ' + pct + '%: es el máximo de ' +
        limitadoPor.corto + '. No todos los aceites admiten la misma ' +
        'proporción' +
        (limitadoPor.motivo ? ': ' + limitadoPor.motivo + ', y por eso su ' +
          'máximo es más bajo.' : ', y el de éste es más bajo.') +
        (nota ? ' ' + nota : '');
    }

    if (textoNota) {
      salidaNota.textContent = textoNota;
      salidaNota.hidden = false;
    } else {
      salidaNota.hidden = true;
    }

    if (tienda && grid && grid.children.length) tienda.hidden = false;
  }

  /* ── los aceites del catálogo ──────────────────────────────── */

  function leerJSON(sel) {
    var el = raiz.querySelector(sel);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  // Dos fuentes: los aceites que vendemos (del catálogo) y los que no (bloques
  // de la sección). Se mezclan porque a quien llega con un aceite de canela le
  // sirve exactamente igual la cuenta — y ésa es la gente que la herramienta
  // tiene que traer. Los nuestros van primero: son los que además puede comprar.
  function cargarCatalogo() {
    var propios = leerJSON('[data-ma-dil-aceites]');
    var externos = leerJSON('[data-ma-dil-externos]');
    catalogo = propios.concat(externos);
    catalogo.forEach(function (a) { a.tope = parseFloat(a.tope) || 0; });
  }

  // Chips para elegir aceite. Se ordenan dejando al final los que no tienen
  // tope: los interesantes para la cuenta son los que sí lo tienen.
  function pintarChips() {
    if (!chips || !catalogo.length) return;
    catalogo.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      // Los que no vendemos se marcan: sirven para la cuenta, pero no tiene
      // sentido que se vean como una oferta.
      b.className = 'ma-dil__chip' + (a.externo ? ' ma-dil__chip--externo' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.textContent = a.corto || a.titulo;
      if (a.cientifico) b.title = a.cientifico;
      b.addEventListener('click', function () {
        var mismo = aceite === a;
        aceite = mismo ? null : a;
        [].slice.call(chips.children).forEach(function (o) {
          var on = !mismo && o === b;
          o.classList.toggle('is-activo', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        pintar();
      });
      chips.appendChild(b);
    });
  }

  function pintarAceites() {
    if (!grid) return;
    var lista = catalogo;
    if (!lista.length) return;

    // Se arma con nodos, no con innerHTML: el título y la imagen vienen del
    // catálogo (los edita quien tenga el admin), y concatenar eso en una
    // cadena de HTML es la receta del XSS. Con createElement no hay parseo.
    var frag = document.createDocumentFragment();
    lista.forEach(function (a) {
      // Sólo rutas internas. Una URL con otro esquema (javascript:) no se pinta.
      if (typeof a.url !== 'string' || a.url.charAt(0) !== '/') return;

      var el = document.createElement('a');
      el.className = 'ma-dil__aceite';
      el.setAttribute('href', a.url);

      if (typeof a.imagen === 'string' && a.imagen) {
        var marco = document.createElement('span');
        marco.className = 'ma-dil__aceite-foto';
        var img = document.createElement('img');
        img.setAttribute('src', a.imagen);
        img.setAttribute('alt', '');
        img.setAttribute('width', '120');
        img.setAttribute('height', '120');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        marco.appendChild(img);
        el.appendChild(marco);
      }

      var nombre = document.createElement('span');
      nombre.className = 'ma-dil__aceite-nombre';
      nombre.textContent = a.titulo;
      el.appendChild(nombre);

      frag.appendChild(el);
    });
    grid.appendChild(frag);
  }

  /* ── eventos ───────────────────────────────────────────────── */

  usos.forEach(function (b) {
    b.addEventListener('click', function () {
      usos.forEach(function (o) {
        o.classList.toggle('is-activo', o === b);
        o.setAttribute('aria-checked', o === b ? 'true' : 'false');
      });
      elegido = b;
      // Un uso sin cifra no necesita preguntar mililitros ni aceite.
      var sinCifra = b.getAttribute('data-sin-numero') === 'true';
      if (paso2) paso2.hidden = sinCifra;
      if (paso3) paso3.hidden = sinCifra || !catalogo.length;
      pintar();
    });
  });

  atajos.forEach(function (b) {
    b.addEventListener('click', function () {
      if (!campoMl) return;
      campoMl.value = b.getAttribute('data-ml');
      atajos.forEach(function (o) { o.classList.toggle('is-activo', o === b); });
      pintar();
    });
  });

  if (campoMl) {
    campoMl.addEventListener('input', function () {
      atajos.forEach(function (o) {
        o.classList.toggle('is-activo', o.getAttribute('data-ml') === campoMl.value);
      });
      pintar();
    });
  }

  cargarCatalogo();
  pintarChips();
  pintarAceites();
})();
